import { CurrencyTwdIcon } from './CurrencyTwdIcon';

/**
 * author: Haley Halcyon
 * id E0103EBC-20BF-48EA-BC8F-BEF04BF2A581
 * name currency-twd
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-twd.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const NewTaiwanDollarIcon = CurrencyTwdIcon;
export default NewTaiwanDollarIcon